// eslint-disable-next-line import/prefer-default-export
export const potValueHandler = (positionType, position) => {
  if (positionType === 'SRP') {
    switch (position) {
      case 'BTNvsBB': {
        return 7.5;
      }
      case 'BTNvsSB': {
        return 8;
      }
      case 'BTNvsSBvsBB': {
        return 10.5;
      }
      case 'COvsBTN': {
        return 8.5;
      }
      case 'SBvsBB': {
        return 6;
      }
      case 'HU_SBvsBB': {
        return 6;
      }
      case 'UTGvsBB': {
        return 7.5;
      }
      case 'UTGvsBTN': {
        return 8.5;
      }
      case 'UTGvsBTNvsBB': {
        return 11;
      }
      case 'limpCheck': {
        return 2;
      }
      case 'limpRaiseCall': {
        return 6;
      }
      default: {
        return 0;
      }
    }
  }
  if (positionType === '3bP') {
    switch (position) {
      case 'BTNvsMPvsCO': {
        return 48;
      }
      case 'SBvsBTN': {
        return 24;
      }
      case 'BTNvsCO': {
        return 25.5;
      }
      case 'BBvsSB': {
        return 18;
      }
      case 'HU_SBvsBB': {
        return 18;
      }
      case 'SBvsCOvsBTN': {
        return 46;
      }
      case 'BTNvsUTG': {
        return 25.5;
      }
      case 'SBvsUTG': {
        return 24;
      }
      default: {
        return 0;
      }
    }
  }
  if (positionType === '4bP') {
    switch (position) {
      case 'BTNvsSB': {
        return 72;
      }
      case 'COvsBTN': {
        return 76.5;
      }
      case 'SBvsBB': {
        return 54;
      }
      case 'HU_SBvsBB': {
        return 54;
      }
      case 'UTGvsBTN': {
        return 76.5;
      }
      case 'UTGvsSB': {
        return 72;
      }
      default: {
        return 0;
      }
    }
  }
  return 0;
};
